import { Helper } from '../Helper';
export class HandlePrefixKeyStructuredStorageHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.unwrapArray);
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.arrLeft);
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'DUP');
                sb.emitOp(node, 'ARRAYSIZE');
                sb.emitPushInt(node, 1);
                sb.emitOp(node, 'NUMEQUAL');
            },
            whenTrue: () => {
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'PICKITEM');
            },
            whenFalse: () => {
                sb.emitHelper(node, options, sb.helpers.wrapArray);
            },
        }));
    }
}

//# sourceMappingURL=HandlePrefixKeyStructuredStorageHelper.js.map
